var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 785.2 171",
    style: {
      enableBackground: "new 0 0 785.2 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#3F4358;}\r\n\t.st2{fill:#46E3B7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    transform: "translate(-15853 -8503)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16140,8582.1c-10,0-17.8,2.6-25.5,6.7v74.4c0,2-1.7,3.9-3.7,3.9h-17c-2,0-3.7-1.8-3.7-3.9v-96.8 c0-2,1.7-3.7,3.7-3.7h16.1c2,0,3.7,1.7,3.7,3.7v3.9c9.1-7,19.1-8.9,26.5-8.9c2,0,3.7,1.7,3.7,3.7v13.3 C16143.7,8580.4,16142,8582.1,16140,8582.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16237.5,8623.3h-60.3v0.6c0,10.7,4.4,23.5,22.2,23.5c13.5,0,26.3-1.1,34-1.9c0.2,0,0.4,0,0.6,0 c1.9,0,3.3,0.9,3.3,2.8v12.2c0,3-0.6,4.3-3.9,4.8c-12,2.2-19.2,3.1-35.9,3.1c-18.5,0-44.8-10-44.8-46.4v-13.7 c0-28.9,16.1-47,44.4-47c28.5,0,44,19.4,44,47v10.4C16241.2,8621.7,16240.1,8623.3,16237.5,8623.3z M16216.6,8605.2 c0-14.4-8-22.8-19.4-22.8s-19.8,8.1-19.8,22.8v0.7h39.2V8605.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16343.8,8667h-17c-2,0-3.7-1.8-3.7-3.9v-60.3c0-16.1-1.5-20.7-15.7-20.7c-6.3,0-13.1,2.6-20.9,6.7v74.4 c0,2-1.7,3.9-3.7,3.9h-17c-2,0-3.7-1.8-3.7-3.9v-96.8c0-2,1.7-3.7,3.7-3.7h16.1c2,0,3.7,1.7,3.7,3.7v3.9c10.7-6.8,17.8-8.9,30-8.9 c26.6,0,32,17.9,32,41.4v60.3C16347.5,8665.2,16345.9,8667,16343.8,8667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16449.3,8663.7c-11.5,3-25.3,4.8-37.2,4.8c-29.8,0-44.2-17.6-44.2-46.4v-14.2c0-28.9,14.4-46.4,44.2-46.4 c4.4,0,10.9,0.4,17.8,1.3v-32.7c0-2,1.7-3.7,3.7-3.7h17c2,0,3.7,1.7,3.7,3.7v128.8C16454.3,8661.5,16453.5,8662.6,16449.3,8663.7z  M16429.9,8582.6c-5.2-0.7-13.3-1.3-17.8-1.3c-15.9,0-19.8,11.3-19.8,26.5v14.2c0,15.2,3.9,26.5,19.8,26.5 c6.7,0,14.2-0.6,17.8-1.3V8582.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16559.9,8623.3h-60.3v0.6c0,10.7,4.4,23.5,22.2,23.5c13.5,0,26.3-1.1,34-1.9c0.2,0,0.4,0,0.6,0 c1.8,0,3.3,0.9,3.3,2.8v12.2c0,3-0.6,4.3-3.9,4.8c-12,2.2-19.2,3.1-35.9,3.1c-18.5,0-44.8-10-44.8-46.4v-13.7 c0-28.9,16.1-47,44.4-47c28.5,0,44,19.4,44,47v10.4C16563.6,8621.7,16562.5,8623.3,16559.9,8623.3z M16539,8605.2 c0-14.4-8-22.8-19.4-22.8c-11.5,0-19.8,8.1-19.8,22.8v0.7h39.2V8605.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16634.5,8582.1c-10,0-17.8,2.6-25.5,6.7v74.4c0,2-1.7,3.9-3.7,3.9h-17c-2,0-3.7-1.8-3.7-3.9v-96.8 c0-2,1.7-3.7,3.7-3.7h16.1c2,0,3.7,1.7,3.7,3.7v3.9c9.1-7,19.1-8.9,26.5-8.9c2,0,3.7,1.7,3.7,3.7v13.3 C16638.2,8580.4,16636.5,8582.1,16634.5,8582.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15966.3,8503 15964.3,8503 15964.3,8505 15964.3,8523.6 15964.3,8525.6 15966.3,8525.6  15984.9,8525.6 15986.9,8525.6 15986.9,8523.6 15986.9,8505 15986.9,8503 15984.9,8503  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15906.5,8503c-7.2,0-14.2,1.4-20.8,4.2c-6.4,2.7-12.1,6.6-17,11.5c-4.9,4.9-8.8,10.6-11.5,17 c-2.8,6.6-4.2,13.6-4.2,20.8v78.4v2h2h18.6h2v-2v-78.7c0.4-8.1,3.8-15.7,9.5-21.3c5.8-5.7,13.4-9,21.5-9.3h41.2h2v-2V8505v-2h-2 H15906.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16003.4,8577.2 16001.4,8577.2 16001.4,8579.2 16001.4,8597.8 16001.4,8599.8 16003.4,8599.8  16022,8599.8 16024,8599.8 16024,8597.8 16024,8579.2 16024,8577.2 16022,8577.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16003.4,8540.1 16001.4,8540.1 16001.4,8542.1 16001.4,8560.7 16001.4,8562.7 16003.4,8562.7  16022,8562.7 16024,8562.7 16024,8560.7 16024,8542.1 16024,8540.1 16022,8540.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16022,8503 16003.4,8503 16001.4,8503 16001.4,8505 16001.4,8523.6 16001.4,8525.6 16003.4,8525.6  16022,8525.6 16024,8525.6 16024,8523.6 16024,8505 16024,8503  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16003.4,8614.3 16001.4,8614.3 16001.4,8616.3 16001.4,8634.9 16001.4,8636.9 16003.4,8636.9  16022,8636.9 16024,8636.9 16024,8634.9 16024,8616.3 16024,8614.3 16022,8614.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16003.4,8651.4 16001.4,8651.4 16001.4,8653.4 16001.4,8672 16001.4,8674 16003.4,8674 16022,8674  16024,8674 16024,8672 16024,8653.4 16024,8651.4 16022,8651.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15966.3,8651.4 15964.3,8651.4 15964.3,8653.4 15964.3,8672 15964.3,8674 15966.3,8674 15984.9,8674  15986.9,8674 15986.9,8672 15986.9,8653.4 15986.9,8651.4 15984.9,8651.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15929.2,8651.4 15927.2,8651.4 15927.2,8653.4 15927.2,8672 15927.2,8674 15929.2,8674 15947.8,8674  15949.8,8674 15949.8,8672 15949.8,8653.4 15949.8,8651.4 15947.8,8651.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15892.1,8651.4 15890.1,8651.4 15890.1,8653.4 15890.1,8672 15890.1,8674 15892.1,8674 15910.7,8674  15912.7,8674 15912.7,8672 15912.7,8653.4 15912.7,8651.4 15910.7,8651.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15855,8651.4 15853,8651.4 15853,8653.4 15853,8672 15853,8674 15855,8674 15873.6,8674  15875.6,8674 15875.6,8672 15875.6,8653.4 15875.6,8651.4 15873.6,8651.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRender);
export default __webpack_public_path__ + "static/media/render.82ab61f303665ccd346ad7780ec6897d.svg";
export { ForwardRef as ReactComponent };